import * as Yup from 'yup';

const TeamSchema = Yup.object({
  managerId: Yup.string().required('Please select a manager'),
  team: Yup.array().min(1, 'Please select a team member'),
});

export default TeamSchema;
